import { memo } from 'react';
import Box from '../Box/Box';
import Text from '../Text/Text';
import Image from '../Image/Image';
import { InfoImageProps } from './InfoImage.types';

function InfoImage({
  image = 'common.error',
  imageWidth = 80,
  imageHeight = 80,
  title,
  titleNS,
  titleKey,
  description,
  descriptionNS,
  descriptionKey,
  children,
  ...rest
}: InfoImageProps) {
  return (
    <Box gap="space-400" {...rest}>
      <Image
        name={image}
        width={imageWidth}
        height={imageHeight}
        alignSelf="center"
      />
      <Text
        variant="h5"
        locKey={titleKey}
        locNS={titleNS}
        textAlign="center"
        color="darkSurfacePrimary"
      >
        {title}
      </Text>
      <Text
        variant="body-m"
        locKey={descriptionKey}
        locNS={descriptionNS}
        textAlign="center"
        color="darkSurfacePrimary"
      >
        {description}
      </Text>
      {children}
    </Box>
  );
}

export default memo(InfoImage);
